export default __webpack_public_path__ + "static/media/3-4-4.e8687fe9.jpg";